import { Box, Button, Icon, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { HeaderQuestionnaire } from "../../../../components/headerQuestionnaire"
import { CustomPaper } from "../../../../components/CustomPaper"
import { ListDetail } from "./components/listDetail/iindex"
import { BreadCrumb, SnackSimple } from "../../../../components"
import { RecurrenceBody } from "./body"
import { useTranslation } from "react-i18next"
import Loader from "../../../../components/loader"
import { icons } from "../../../../utils/icons"
import { useNavigate } from "react-router-dom"
import { useBreadCrumbContext } from "../../../../components/breadCrumb/context/breadCrumbContext"
/* import { getPreviousBreadList } from "../../../../components/breadCrumb/mthods/routesHistory" */

const RecurrenceAlert = () => {
    const { t } = useTranslation()
    const styles = useStyles()
    const navigate = useNavigate()

    const { getPreviousBreadList } = useBreadCrumbContext();

    const path = getPreviousBreadList();

    return (
        <RecurrenceBody >
            {({ questionnaireData, isLoading, recurrencesList, ids, snackbar, closeSnackbar, goReportFolioOrActionPlan }) => {
                const historieLength = questionnaireData?.amountRecurrencesCreated
                return (
                    isLoading ? <Loader /> :
                        (

                            <Box sx={styles.container}>
                                <BreadCrumb
                                    removeBreadcrumb={['calendar', 'schedule-user']}
                                />

                                {/* {!!questionnaireData && <HeaderQuestionnaire {...questionnaireData} />} */}

                                <CustomPaper sx={styles.body}>
                                    <Box sx={styles.header}>
                                        <Button onClick={
                                            () => { 
                                                if(path?.state) {
                                                    navigate(path.path, {state: path?.state})
                                                    return 
                                                }
                                                navigate(path.path, )
                                            }
                                        } sx={styles.backButton} variant="text_primary">{t('schedule.buttons.returnToQuestionnaireDetail')}</Button>

                                        <Box sx={styles.actions}>
                                            <Typography variant="subtitle_grey" fontWeight='bold'>{t('general.recurrenceAmmount', { ammount: historieLength })}</Typography>

                                            <Box sx={styles.alert({ ammount: historieLength })}>
                                                <Icon>{icons('warning')}</Icon>

                                                <Typography variant="subtitle" fontWeight='500'>{t('general.recurrenceAlert')}</Typography>
                                            </Box>

                                            <Button disabled={!ids?.reportFolio} onClick={() => { goReportFolioOrActionPlan({ name: 'report-folio', id: ids?.reportFolio }) }} variant="text_primary">{t('general.seeLastReportFolio')}</Button>

                                            <Button disabled={!ids?.actionPlan} onClick={() => { goReportFolioOrActionPlan({ name: 'action-plan', id: ids?.actionPlan }) }} variant="text_primary">{t('general.seeLastActionPlan')}</Button>
                                        </Box>
                                    </Box>

                                    {
                                        !!recurrencesList && (
                                            <>
                                                <Box sx={styles.footer}>
                                                    <Typography variant="subtitle_grey" color='c_red.main' fontWeight='600'>{recurrencesList.answer}</Typography>

                                                    <Typography variant="subtitle_grey" fontWeight='bold'>{recurrencesList.item}</Typography>

                                                    <Typography variant="subtitle_grey" fontWeight='600'>{recurrencesList.date}</Typography>
                                                </Box>

                                                <Box sx={styles.comments}>
                                                    <ListDetail
                                                        title={t('general.incidence')}
                                                        itemList={recurrencesList.currenceRecurrence?.itemList}
                                                    />

                                                    {
                                                        !!recurrencesList?.historyRecurrence?.itemList?.length && (
                                                            <ListDetail
                                                                existed
                                                                title={t('general.incidenceHistorie')}
                                                                itemList={recurrencesList?.historyRecurrence?.itemList}
                                                            />
                                                        )
                                                    }
                                                </Box>
                                            </>
                                        )
                                    }
                                </CustomPaper>

                                <SnackSimple close={closeSnackbar} open={snackbar?.open} type={snackbar?.type} message={snackbar?.message} />
                            </Box>
                        )
                )
            }
            }
        </RecurrenceBody>
    )


}

export default RecurrenceAlert